import Vue from "vue";
import { LMap, LTileLayer, LMarker, LTooltip, LPopup, LCircleMarker, LControlZoom, LWMSTileLayer, LCircle } from "vue2-leaflet";
import { Icon } from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet/dist/images/marker-icon.png";
import "./Bing.js";
import "@sintef/prune-cluster/dist/LeafletStyleSheet.css";

Vue.component("l-map", LMap);
Vue.component("l-tile-layer", LTileLayer);
Vue.component("l-wms-tile-layer", LWMSTileLayer);
Vue.component("l-marker", LMarker);
Vue.component("l-tooltip", LTooltip);
Vue.component("l-popup", LPopup);
Vue.component("l-circle-marker", LCircleMarker);
Vue.component("l-control-zoom", LControlZoom);
Vue.component("l-circle", LCircle);

type D = Icon.Default & {
  _getIconUrl: string;
};

delete (Icon.Default.prototype as D)._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});
